const searchInput = {

    input: document.querySelector('.jsSearchInput') as HTMLInputElement, 
    btn: document.getElementById('jsSearchBtn') as HTMLElement,


    init() {
        this.resetSearchInput();
    },

    resetSearchInput() {
        if(this.input) {
        this.input.addEventListener('input', () => {

        const inputValue = this.input.value; 

        if(this.input.value !== '') {
            this.btn.classList.remove('d-none');
        }

        if(this.input.value === '') {
            this.btn.classList.add('d-none');
        }

        this.btn.addEventListener('click', () => {
            this.input.value = '';
            this.btn.classList.add('d-none');
        });

        }); 
    }
    }



};

export default searchInput;